<ngx-spinner type="ball-clip-rotate"></ngx-spinner>
<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-suguyaku-login></app-suguyaku-login>
  </div>

  <div *ngIf="page === 'register'">
    <app-suguyaku-register></app-suguyaku-register>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-suguyaku-forgot-password></app-suguyaku-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-suguyaku-change-password-sent></app-suguyaku-change-password-sent>
  </div>

  <app-suguyaku-register-resend
    *ngIf="page === 'register-resend'"
  ></app-suguyaku-register-resend>
</ng-container>
